import { render, staticRenderFns, recyclableRender, components } from "./settlementDetails.vue?vue&type=template&id=20696aba&scoped=true&"
var renderjs
import script from "./settlementDetails.vue?vue&type=script&lang=js&"
export * from "./settlementDetails.vue?vue&type=script&lang=js&"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./settlementDetails.vue?vue&type=style&index=1&id=20696aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20696aba",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/settlementDetails/settlementDetails.vue"
export default component.exports